import { render, staticRenderFns } from "./blacklist.vue?vue&type=template&id=61fd3ce4&"
import script from "./blacklist.vue?vue&type=script&lang=js&"
export * from "./blacklist.vue?vue&type=script&lang=js&"
import style0 from "./blacklist.vue?vue&type=style&index=0&id=61fd3ce4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports